<button
  type="button"
  class="nav-group-trigger"
  [attr.aria-expanded]="isOpen()"
  [attr.aria-haspopup]="true"
  [attr.aria-controls]="'nav-group-menu-' + groupId()"
  (click)="onTriggerClick()"
>
  <app-header-nav-icon [iconId]="iconId()" />
  <span class="nav-label">{{ labelKey() | translate }}</span>
</button>

<div
  [id]="'nav-group-menu-' + groupId()"
  class="nav-group-menu"
  role="menu"
  [attr.aria-label]="labelKey() | translate"
  [attr.aria-hidden]="!isOpen()"
>
  @for (item of items(); track item.id) {
    <button
      type="button"
      class="nav-group-item"
      role="menuitem"
      [class.selected]="isItemSelected(item)"
      (click)="onItemClick(item)"
      (mouseenter)="onItemHover(item.url)"
    >
      <app-header-nav-icon [iconId]="item.iconId" />
      <span class="nav-label">
        @if (item.titlecase) {
          {{ item.labelKey | translate | titlecase }}
        } @else {
          {{ item.labelKey | translate }}
        }
      </span>
    </button>
  }
</div>
